import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UserService} from '../../shared';

@Component({
    selector: 'jhi-user-club-modal',
    templateUrl: './user-club-modal.component.html',
    styleUrls: ['./user-club-modal.component.scss'],
})
export class UserClubModalComponent implements OnInit {
    isSuccessMessageActive = false;
    isErrorMessageActive = false;
    isLoadingMessageActive = false;
    isTermsChecked = false;
    isSubmitted = false;


    constructor(public activeModal: NgbActiveModal,
                private userService: UserService
    ) {
    }

    ngOnInit(): void {
        // RGAA workaround
        const modalEl = document.querySelector('ngb-modal-window'); // Sélectionnez l'élément modal ng-bootstrap
        modalEl.setAttribute('aria-label', 'S’inscrire au club utilisateur de Télérecours citoyens'); // Ajoutez l'attribut aria-label
    }

    private showSuccessMessage = () => {
        this.isLoadingMessageActive = false;
        this.isSuccessMessageActive = true;
        this.isSubmitted = false;
    }

    private showErrorMessage = () => {
        this.isLoadingMessageActive = false;
        this.isErrorMessageActive = true;
    }

    private showLoadingMessage = () => {
        this.isSuccessMessageActive = false;
        this.isErrorMessageActive = false;
        this.isLoadingMessageActive = true;
    }

    onJoinUserClub = () => {
        this.isSubmitted = true;
        if (this.isTermsChecked) {
            this.showLoadingMessage();
            this.userService.subscribeUserClub().then(() => {
                this.showSuccessMessage();
                this.userService.auth2.next(false);
            }).catch(() => {
                this.showErrorMessage();
            });
        }
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/app/user-club/user-club-modal/user-club-modal.component.ts